import React, { useContext } from 'react';
import Faq from './Faq';
import ConfigContext from '../../../contexts/ConfigContext';

const getOfficeFaqQuestions = (siteTitle, vehicleType) => [
  {
    question: `How do food ${vehicleType}s work at offices and corporate campuses?`,
    answer: `A ${vehicleType} visits on a set schedule and sells lunch to employees or tenants. We build and manage the rotation, handle scheduling, and keep you and the ${vehicleType}s in the loop. Each ${vehicleType} arrives self-contained, serves on site, and leaves with nothing for your team to clean up.`
  },
  // Pricing per the client (4 Sep 2026) and the 7 Sep owner decision: hosted
  // service is a program fee quoted up front, self-serve through the catering
  // form carries no program fee, and no price list is published. Same answer
  // as the page's "What it costs" card.
  {
    question: `Does it cost businesses anything to host food ${vehicleType}s on-site?`,
    answer: `Most workplaces have us run it. Hosted service is a monthly program fee we quote up front, and we handle the schedule, the ${vehicleType}s, and the day-of details. Employees buy lunch at the ${vehicleType}, or the company can cover part or all of it. Prefer to run it yourself? Submit a recurring request through the catering form and pick your own ${vehicleType}s. There's no program fee that way.`
  },
  {
    question: `How often can food ${vehicleType}s come to my workplace?`,
    answer: `Daily, weekly, or on a rotation, depending on your location and how many people will show up. Most offices settle on a consistent schedule so people know when to expect a ${vehicleType}, with the cuisine changing week to week.`
  },
  {
    question: `What space or setup is required to host a food ${vehicleType} at work?`,
    answer: `A flat parking area about 30 ft by 8 ft. Most ${vehicleType}s bring their own power and water and don't need kitchen access. If you're unsure about access, traffic flow, or timing, we'll work it out with you before the first visit.`
  },
  {
    question: 'Can employees pre-order or pay for food online?',
    answer: `Employees order at the ${vehicleType}, and many ${vehicleType}s also take online orders so people can skip the line. A weekly menu email and a page for your workplace show which ${vehicleType}s are scheduled, so people can plan ahead.`
  },
  {
    question: `Why are food ${vehicleType}s a good workplace perk for employees?`,
    answer: `Lunch shows up outside the door, the menu changes week to week, and nobody on your team has to run it. It's a simpler perk than a cafeteria.`
  }
];

function OfficeFaq() {
  const { site_title, vehicle_type } = useContext(ConfigContext);
  const vehicleType = vehicle_type.toLowerCase();

  const questions = getOfficeFaqQuestions(site_title, vehicleType);

  return (
    <Faq questions={questions} />
  );
}

export default OfficeFaq;
